module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/exclamation-icon-24c20c927ab1e3cb34a4b6d874f1f3d2.png";